import { api } from '../index';
import {
  IDefaultSuccessResponse,
  ITableParams,
  TPaginatedListResponse,
} from '../baseApiTypes';
import { IEventsResponse } from './type';

export const getEvents = (params: ITableParams) =>
  api.get('/events', { params });

export const createEvents = (data: any) => api.post('/events', data);

export const getSingleEvents = (id: number | string) =>
  api.get<IDefaultSuccessResponse<IEventsResponse>>(`/events/${id}`);
export const getThreeEvents = () => api.get(`/events`);
export const getAllEvents = () => api.get(`/events/all`);

export const getAllEventsList = (params: ITableParams) =>
  api.get<TPaginatedListResponse<IEventsResponse>>(`/events/list`, { params });

export const editEvent = (props: { data: any; id: string | number }) =>
  api.post(`/events/${props.id}`, props.data);

export const deleteEvent = (id: number | string) => api.delete(`/events/${id}`);

// @ts-ignore
export const updateEvents = ({ id, data }) =>
  api.post(`/events/update/${id}`, data);
// @ts-ignore
export const uploadEvents = ({ data }) => api.post(`/events/update/`, data);

export const deleteEvents = (id: any) => api.get(`/events/delete/${id}`);

export const EventsApi = {
  editEvent,
  getAllEvents,
  getThreeEvents,
  uploadEvents,
  getEvents,
  createEvents,
  getSingleEvents,
  updateEvents,
  deleteEvents,
  getAllEventsList,
  deleteEvent,
};
